import type { DicStayAreaGeoResolveResult, DicStayAreaListFilters, DicStayAreaMutation } from "../types";

/** 归一化住宿点筛选条件。 */
export function normalizeDicStayAreaFilters(
  filters: DicStayAreaListFilters,
): DicStayAreaListFilters {
  return {
    keyword: normalizeOptionalText(filters.keyword),
    province: normalizeOptionalText(filters.province),
    city: normalizeOptionalText(filters.city),
    isDisabled: filters.isDisabled,
  };
}

/** 根据 GEO 识别结果回填表单。 */
export function applyGeoResolveResultToMutation(
  payload: DicStayAreaMutation,
  result: DicStayAreaGeoResolveResult,
): DicStayAreaMutation {
  if (result.status ? result.status !== "confirmed" : result.needsReview) return payload;
  return {
    ...payload,
    province: result.province || payload.province,
    city: result.city,
    district: result.district,
    township: result.town || payload.township,
    navigationAddress: result.navigationAddress,
    lng: result.longitude,
    lat: result.latitude,
    areaLevel: payload.areaLevel,
  };
}

/** 按当前表单组装 GEO 识别区域名称。 */
export function buildGeoResolveAreaName(payload: DicStayAreaMutation) {
  return payload.stayAreaName.trim();
}

/** 归一化可选查询文本。 */
function normalizeOptionalText(value?: string) {
  const normalized = value?.trim();
  return normalized ? normalized : undefined;
}
